import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useScrollOver } from '@gluedigital/scrollastic'
import './Intro.sass'

const Intro = () => {
  const progress = useScrollOver('#intro')

  return (
    <section className="section" id="intro">
      <div id="stroke-intro-1" className="stroke"
        style={{ transform: `translateY(${progress * 45}vh` }} />
      <div id="stroke-intro-2" className="stroke"
        style={{ transform: `translateY(${progress * -65}vh` }} />
      <div className="container">
        <div className="split">
          <div className="item left">
            <h1>
              <FormattedMessage id="home.intro.title" />
            </h1>
            <p>
              <FormattedMessage id="home.intro.text-1" />
            </p>
            <p>
              <FormattedMessage id="home.intro.text-2" />
            </p>
          </div>
          <div className="item right">
            <div id="intro-image" />
          </div>
        </div>
      </div>
      <div id="stroke-intro-3" className="stroke"
        style={{ transform: `translateY(${progress * -90}vh` }} />
      <div id="stroke-intro-4" className="stroke"
        style={{ transform: `translateY(${progress * 70}vh` }} />
    </section>
  )
}

export default Intro
